const trim = require('mn-utils/trim');
const formatTime = require('mn-utils/formatTime');
const get = require('mn-utils/get');

function asDoc(doc) {
  return doc ? {
    fileId: doc.id,
    name: doc.file_name || doc.id,
  } : null;
}
export function prepareItemForResponse(director) {
  const {
    date_of_birth: dateOfBirth,
  } = director;
  return {
    ...director,
    fullname: director.full_name,
    birthday: dateOfBirth ? new Date(dateOfBirth) : dateOfBirth,
    percentShares: director.owner_percent,
    countryOfResidence: director.country_of_residence,
    countryOfBirth: director.country_of_birth,
    passportOrNationId: director.passport_or_nation_id,
    docDirectorsPassportOrNationalId: asDoc(director.document_identity),
    docDirectorsProofOfAddress: asDoc(director.document_address),
  };
}

export function prepareItemForRequest(state) {
  const birthday = state.birthday;

  return {
    id: state.id,
    full_name: state.fullname,
    date_of_birth: birthday && !isNaN(birthday)
      ? formatTime(birthday, '{yyyy}-{mm}-{dd}')
      : '',
    owner_percent: state.percentShares,
    country_of_residence: state.countryOfResidence,
    country_of_birth: state.countryOfBirth,
    country_of_document: state.countryOfBirth, // delete
    owner_type: 'beneficial', // delete
    passport_or_nation_id: state.passportOrNationId,
    document_identity: get(state, 'docDirectorsPassportOrNationalId.fileId'),
    document_address: get(state, 'docDirectorsProofOfAddress.fileId'),
  };
}

export function prepareItem(state) {
  const invalidFullname = !trim(state.fullname);
  const invalidPercentShares = !trim(state.percentShares);
  const invalidBirthday = !state.birthday;
  const invalidCountryOfResidence = !state.countryOfResidence;
  const invalidCountryOfBirth = !state.countryOfBirth;
  const invalidPassportOrNationId = !state.passportOrNationId;

  const invalidDocDirectorsPassportOrNationalId
    = state.loadingDocDirectorsPassportOrNationalId
    || !state.docDirectorsPassportOrNationalId;
  const invalidDocDirectorsProofOfAddress
    = state.loadingDocDirectorsProofOfAddress
    || !state.docDirectorsProofOfAddress;


  return {
    id: state.id,
    disabled: invalidFullname
      || invalidPercentShares
      || invalidBirthday
      || invalidCountryOfResidence
      || invalidCountryOfBirth
      || invalidPassportOrNationId
      || invalidDocDirectorsPassportOrNationalId
      || invalidDocDirectorsProofOfAddress,
    state,
    invalid: {
      fullname: invalidFullname,
      percentShares: invalidPercentShares,
      birthday: invalidBirthday,
      countryOfResidence: invalidCountryOfResidence,
      countryOfBirth: invalidCountryOfBirth,
      passportOrNationId: invalidPassportOrNationId,
      docDirectorsPassportOrNationalId:
        invalidDocDirectorsPassportOrNationalId,
      docDirectorsProofOfAddress: invalidDocDirectorsProofOfAddress,
    },
  };
}
